import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { SecretariaService } from '../../secretaria.service';
import { AlertsService } from 'app/shared/alerts.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';
import { ModalsService } from 'app/shared/modals.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Medico } from 'app/core/interfaces/medico.interface';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { Secretaria } from 'app/core/interfaces/secretaria.interface';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';
import { logger } from '../../../../core/utils/console';
import { error, log } from 'console';

@Component({
  selector: 'app-secretaria-alterar-paciente',
  templateUrl: './secretaria-alterar-paciente.component.html',
  styleUrls: ['./secretaria-alterar-paciente.component.scss']
})
export class SecretariaAlterarPacienteComponent implements OnInit, AfterViewInit {

  loading: boolean = true; 
  paciente_id: string; 
  paciente: Paciente;
  oldPage: number;
  secretaria: Secretaria = Secretaria.createEmpty();
  organizacao: Organizacao;

  emails_medicos: Medico[];
  emails_enfermeiros: Enfermeiro[];

  form: FormGroup; 

  @ViewChild('imageUploader') image_uploader; 
  @ViewChild('cadastro_paciente') componente_cadastro_paciente; 
  
  constructor(
    private router: Router, 
    private secretariaService: SecretariaService, 
    private snackService: AlertsService, 
    private modalService: ModalsService, 
    private _apigestacard: APIGestaCardService, 
  ) {

    try {

      const navigation = this.router.getCurrentNavigation();

      if (navigation && navigation.extras && navigation.extras.state) {
        const state = navigation.extras.state;
        if (state.id) {
          this.paciente_id = state.id; 
          this.oldPage = state.oldPage || 1;
        } else {
          this.router.navigateByUrl('/secretaria');
        }
      } else {
        this.router.navigateByUrl('/secretaria');
      }

    } catch(err) {

      logger.log('SecretariaAlterarPacienteComponent -> constructor -> err', err);
      this.router.navigateByUrl('/secretaria');

    }
     
  }

  ngOnInit() {
    this.form = this.componente_cadastro_paciente.form; 
  }

  ngAfterViewInit() {

    this.BuscarDados();
  
  }

  BuscarDados() {
    this.secretariaService.GetUserData().subscribe((res) => {
      this.secretaria = res;

      this.secretariaService.GetListaMedicos().subscribe((res) => {
        this.emails_medicos = res; 
      });

      this.secretariaService.GetListaEnfermeiros().subscribe((res) => {
        this.emails_enfermeiros = res; 
      });

      this.secretariaService.GetOrgData().subscribe((org) => {
        this.organizacao = org;

        if (this.paciente_id) {
          this.secretariaService.GetPacientePorIdObs(this.paciente_id).subscribe((res) => {
            if ('qual_plano' in res) res['qual_plano'] = res['qual_plano'].toUpperCase();
            this.paciente = res;

            this.AtualizarFormulario(); 

            this.loading = false; 
          })
        }
      })
    });
  }

  AtualizarFormulario() {
    if (this.paciente) this.form.patchValue(this.paciente); 

    this.form.controls.cns.disable();
    if (this.form.controls.cpf.value) this.form.controls.cpf.disable();

    if (this.organizacao.instituicao_publica === 'S') {
      this.form.setControl('enfermeiro_app', new FormControl(this.paciente.enfermeiro_app, []));
      this.form.setControl('medico_app', new FormControl(this.paciente.medico_app, []));
      return
    }
    
    this.form.setControl('enfermeiro_app', new FormControl(this.paciente.enfermeiro_app, []));
    this.form.removeControl('cns');
  }

  async Alterar() {

    if (this.form.valid) {

      var novo_objeto_paciente = { ...this.paciente, ...this.form.getRawValue() };

      if (this.image_uploader.foto_mudou) {

        try {

          var imagem = this.image_uploader.imagePath;
          var image_to_upload = imagem[0];
          var url_imagem = await this._apigestacard.UploadImage(image_to_upload);

          novo_objeto_paciente['url'] = url_imagem;

        } catch (err) {

          this.snackService.SnackMessage('Erro ao atualizar a imagem do paciente');
          return;

        }
      }
      
      delete novo_objeto_paciente['cartao_gestante'];

      if (!novo_objeto_paciente['cpf']) delete novo_objeto_paciente['cpf'];

      this.secretariaService.AtualizarPaciente(novo_objeto_paciente).then((res) => {

        this.snackService.SnackMessage('Paciente atualizado com sucesso!'); 

        const navigationExtras: NavigationExtras = {
          state: {
            page: this.oldPage,
          }
        };

        this.router.navigate(['/secretaria'], navigationExtras); 

      }).catch((err) => {

        this.snackService.SnackMessage('Erro ao atualizar o paciente'); 
        
      })

    } else {
      let errors: Array<string> = [];
      let error = 'Por favor, verifique os campos e tente novamente.';
      
      Object.keys(this.form.controls).forEach(controlName => {
        const control = this.form.get(controlName);

        if (control && control.errors) Object.keys(control.errors).forEach(errorKey => {
          errors.push(`Campo ${controlName} ${errorKey}`);
        });
      });

      if (errors.length > 0) error += ' Erros encontrados: ' + errors.join(', ');

      this.snackService.SnackMessage(error);
    }

  }

  DeletarPaciente() {
    
    this.modalService.AbrirModalDeConfirmacao('Excluir Paciente', 'Tem certeza que deseja excluir esse paciente? Essa ação não poderá ser desfeita!, deseja continuar?').subscribe((res:boolean) => {
      
      if (res) this.secretariaService.DeletarPaciente(this.paciente.email, this.paciente_id).then((res) => {
       
        this.snackService.SnackMessage('Usuario excluido com sucesso!'); 

        const navigationExtras: NavigationExtras = {
          state: {
            page: this.oldPage,
          }
        };

        this.router.navigate(['/secretaria'], navigationExtras);

      })

    });

  }

  ResetPassword() {

    this.modalService.AbrirModalDeConfirmacao('Redefinir Senha', 'Confirma o envio do link de redefinição de senha para o usuário, no email  '+this.paciente.email+'?').subscribe((res:boolean) => {
      
      if (res) this.secretariaService.EmailResetPaciente(this.paciente.email).then((res) => {

        this.snackService.SnackMessage('Link de definição de senha enviado para o e-mail da paciente: '+this.paciente.email); 

        const navigationExtras: NavigationExtras = {
          state: {
            page: this.oldPage,
          }
        };

        this.router.navigate(['/secretaria', navigationExtras]); 

      });

    });

  }

  Voltar() {
    const navigationExtras: NavigationExtras = {
      state: {
        page: this.oldPage,
      }
    };

    this.router.navigateByUrl('/secretaria', navigationExtras);
  }

}
